const actionTypes = {
    SET_MODAL_DOCUMENT_ADD_ACTIVE_STATUS: 'setModalDocumentAddActivedStatus',
    SET_MODAL_DOCUMENT_ADD_CANCEL_ACTIVE_STATUS: 'setModalDocumentAddCancelActivedStatus',
    SET_MODAL_DOCUMENT_ADD_SUBMIT_ACTIVE_STATUS: 'setModalDocumentAddSubmitActivedStatus',
    SET_DOCUMENT_ADD_ITEMS: 'setDocumentAddItems',
    SET_REMARK_CHECK_ERROR: 'setRemarkCheckError',
    SET_HAS_ERR: 'setHasErr',
    SET_ADD_OK: 'setAddOk',
    SET_DOCUMENT_DATAS: 'setDocumentDatas',
}

export default actionTypes